import { Flex, Text } from '@chakra-ui/react';
import { Button, Modal } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';

interface Props {
  onDelete: () => void;
  onClose: () => void;
}

const ConfirmDeleteEnqueuedReviewerModal = ({ onDelete, onClose }: Props) => {
  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      width="448px"
      closeButtonProps={{ hidden: true }}
    >
      <Flex flexDirection="column" gap={6} padding={8}>
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          style={{ width: '40px', height: '40px' }}
          color="actionSecondaryCautionContent"
        />

        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingGroup">Remove Reviewer?</Text>
          <Text textStyle="textBody">
            This action is irreversible. To add this Reviewer again, you will
            need to invite them once more to your Reviewer list.{' '}
          </Text>
        </Flex>

        <Flex justifyContent="flex-end" gap={2}>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="caution" onClick={onDelete}>
            Remove Reviewer
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default ConfirmDeleteEnqueuedReviewerModal;
